module.exports = __webpack_public_path__ + "img/100-chill.626b1a56.png";